import Service from "../BaseService";

const getVehicle = (val: string) =>
  Service.get("/vehicle", {
    params: { val },
    nonLoading: true,
  });

const XypService = {
  getVehicle,
};

export default XypService;
